import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ width = '100%', height = 500 }) => (
  <ContentLoader
    speed={2}
    style={{ width, height }}
    backgroundcolor="#f3f3f3"
    foregroundcolor="#ecebeb"
  >
    <rect x="20" y="0" rx="6" ry="6" width="30%" height="30" />
    <rect x="20%" y="100" rx="6" ry="6" width="30%" height="30" />
    <rect x="20%" y="150" rx="6" ry="6" width="60%" height="20" />
    <rect x="20%" y="180" rx="6" ry="6" width="60%" height="20" />
    <rect x="20%" y="210" rx="6" ry="6" width="45%" height="20" />
    <rect x="20%" y="250" rx="6" ry="6" width="30%" height="25" />
    <rect x="20%" y="285" rx="6" ry="6" width="60%" height="40" />
    <rect x="20%" y="330" rx="6" ry="6" width="60%" height="40" />
    <rect x="20%" y="375" rx="6" ry="6" width="60%" height="40" />
  </ContentLoader>
);

export default Loader;
